import { Form, Switch } from "antd";
import React from "react";

const NCD: React.FC = () => {
  return (
    <Form.Item name="hasNCD" label="NCD?">
      <Switch />
    </Form.Item>
  );
};

export default NCD;
